import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  MfgBuildModelCreateResponse,
  MfgBuildModelsListResponse,
  MfgBuildModelUpdateResponse,
  MfgCogsPreviewResponse,
  MfgPtlDeliveryByModelListResponse,
  MfgPtlDeliveryByModelUpsertResponse,
  MfgPtlDerivationMetadata,
} from "@/lib/manufacturing/cogsTypes";

export async function listManufacturingBuildModels(filters?: {
  series?: string;
  roof_style?: string;
  size_band?: string;
  is_active?: boolean;
}) {
  const qs = new URLSearchParams();
  if (filters?.series) qs.set("series", filters.series);
  if (filters?.roof_style) qs.set("roof_style", filters.roof_style);
  if (filters?.size_band) qs.set("size_band", filters.size_band);
  if (typeof filters?.is_active === "boolean") qs.set("is_active", String(filters.is_active));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return manufacturingFetch<MfgBuildModelsListResponse>(`/api/mfg/build-models${suffix}`, {
    method: "GET",
  });
}

export async function createManufacturingBuildModel(body: {
  recipe_id: string;
  model_code: string;
  name: string;
  series?: string;
  roof_style?: string;
  size_band?: string;
  retail_margin_denom?: number | null;
  wholesale_margin_denom?: number | null;
  rto_margin_denom?: number | null;
  employee_margin_denom?: number | null;
  flat_labor_rate_usd?: number;
  is_active?: boolean;
  notes?: string;
}) {
  return manufacturingFetch<MfgBuildModelCreateResponse>("/api/mfg/build-models/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function updateManufacturingBuildModel(body: {
  model_id: string;
  model_code?: string;
  name?: string;
  series?: string;
  roof_style?: string;
  size_band?: string;
  retail_margin_denom?: number | null;
  wholesale_margin_denom?: number | null;
  rto_margin_denom?: number | null;
  employee_margin_denom?: number | null;
  flat_labor_rate_usd?: number;
  is_active?: boolean;
  notes?: string;
}) {
  return manufacturingFetch<MfgBuildModelUpdateResponse>("/api/mfg/build-models/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function previewManufacturingCogs(params: { model_id: string; plant_id: string }) {
  const qs = new URLSearchParams({
    model_id: params.model_id,
    plant_id: params.plant_id,
  });
  return manufacturingFetch<MfgCogsPreviewResponse>(`/api/mfg/cogs/preview?${qs.toString()}`, {
    method: "GET",
  });
}

export async function listManufacturingPtlDeliveryByPlant(plantId: string) {
  const qs = new URLSearchParams({ plant_id: plantId });
  return manufacturingFetch<MfgPtlDeliveryByModelListResponse>(
    `/api/mfg/ptl-delivery-by-model?${qs.toString()}`,
    { method: "GET" },
  );
}

export async function upsertManufacturingPtlDeliveryByModel(body: {
  plant_id: string;
  model_id: string;
  ptl_amount_usd: number;
  derivation_metadata?: MfgPtlDerivationMetadata | null;
}) {
  return manufacturingFetch<MfgPtlDeliveryByModelUpsertResponse>("/api/mfg/ptl-delivery-by-model", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
